import { makeStyles } from '@material-ui/styles';

const useImageEditorEditStyles = makeStyles({
  container: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    '& .title': {
      textAlign: 'start',
      fontSize: '18px'
    },
    '& .curImg': {
      width: '250px',
      height: '220px',
      objectFit: 'contain',
      margin: 'auto'
    },
    '& .removeBtn': {
      marginTop: '10px',
      margin: 'auto',
      width: '250px'
    }
  }
});

export default useImageEditorEditStyles;
